import {
  ApolloClient,
  InMemoryCache,
  makeVar,
  createHttpLink,
  split,
} from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { GraphQLWsLink } from "@apollo/client/link/subscriptions";
import { getMainDefinition } from "@apollo/client/utilities";
import { createClient } from "graphql-ws";

import { LOCALSTORAGE_TOKEN } from "./contants";

const token = localStorage.getItem(LOCALSTORAGE_TOKEN);

export const isLoggedInVar = makeVar(Boolean(token));
export const authTokenVar = makeVar(token);
export const godModeVar = makeVar(false);
export const adminTokenVar = makeVar("");

// postgres://fvhsnyqlawxaze:7fb2f822d30ead29bded5ac6dbbc36b07cd93db44ce85a4463d17ca1572daaff@ec2-54-195-144-105.eu-west-1.compute.amazonaws.com:5432/dde50lrq5aftip
// export const url = "http://192.168.1.56:5000"
// export const url = "http://192.168.1.117";
// export const url = "http://192.168.0.122";
// export const url = "http://localhost";
// export const url = "http://192.168.1.162";
// export const url = "https://scalance.cloud";
// export const uri = url + "/graphql";
// const uri = "https://web-production-79519.up.railway.app/graphql";
const uri = "https://web-production-0c976.up.railway.app/graphql";
const wsUri = uri.replace(/^http/, "ws");

const httpLink = createHttpLink({
  uri,
});

const authLink = setContext((_, { headers }) => {
  return {
    headers: {
      ...headers,
      "x-jwt": authTokenVar() || null,
    },
  };
});

const wsLink = new GraphQLWsLink(
  createClient({
    url: wsUri,
    connectionParams: () => ({
      "x-jwt": authTokenVar() || null,
    }),
  })
);

const splitLink = split(
  ({ query }) => {
    const definition = getMainDefinition(query);
    return (
      definition.kind === "OperationDefinition" &&
      definition.operation === "subscription"
    );
  },
  wsLink,
  authLink.concat(httpLink)
);

export const client = new ApolloClient({
  link: splitLink,

  // Les écrans doivent refléter l'état du serveur après une mutation : on affiche
  // immédiatement le cache, puis on revalide sur le réseau (le défaut `cache-first`
  // resservait des données périmées, notamment au retour sur une page déjà visitée).
  defaultOptions: {
    watchQuery: {
      fetchPolicy: "cache-and-network",
      nextFetchPolicy: "cache-and-network",
    },
  },

  cache: new InMemoryCache({
    typePolicies: {
      Query: {
        fields: {
          isLoggedIn: {
            read() {
              return isLoggedInVar();
            },
          },

          token: {
            read() {
              return authTokenVar();
            },
          },

          godMode: {
            read() {
              return godModeVar();
            },
          },
        },
      },
    },
  }),
});
